export default "__VITE_ASSET__DwrLMOOg__"